import React, { Component } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

import "./css/Ability.css";
export default class Ability extends Component {
  render() {
    const { ability } = this.props;
    return (
      <ReactCSSTransitionGroup
        transitionName="updateFade"
        transitionEnterTimeout={500}
        transitionLeave={true}
        transitionLeaveTimeout={500}
        transitionAppear={true}
        transitionAppearTimeout={500}
      >
        <div
          className="ability "
          style={this.props.style}
          onClick={this.props.selectAbility}
          key={ability.name + ability.type}
        >
          <img
            draggable={false}
            alt="ability"
            className={`abilityImage ${this.props.active ? "active" : ""}`}
            src={`https://s3.eu-central-1.amazonaws.com/static.battlerite.com/www3/images/static/winter_megapatch/images/ability-icons/${ability.name
              .toLowerCase()
              .replace(" ", "")}.png`}
          />

          <p className="ability-type">{ability.type.toUpperCase()}</p>
        </div>
      </ReactCSSTransitionGroup>
    );
  }
}
